export default __webpack_public_path__ + "e8b5b4e69e310fcf65f6b5dbf678c320.svg";